(function(){
  'use strict';

  var root=document.querySelector('.ezarc-event');
  if(!root)return;

  var q=function(selector,scope){return(scope||root).querySelector(selector);};
  var qa=function(selector,scope){return Array.prototype.slice.call((scope||root).querySelectorAll(selector));};
  var isShopify=!!root.closest('.shopify-section');
  var imageFallback='https://images.unsplash.com/photo-1516627145497-ae6968895b74?auto=format&fit=crop&w=800&q=80';
  var productFallback=root.getAttribute('data-local-fallback')||'assets/ezarc-product-802060.png';
  var heavyProductFallback=root.getAttribute('data-local-fallback-heavy')||'assets/ezarc-product-802067.png';

  function formatLikes(value){
    value=Math.max(0,Math.round(Number(value)||0));
    if(value>=1000)return(value/1000).toFixed(1).replace('.0','')+'K';
    return String(value);
  }

  function parseLikes(value){
    var text=String(value||'0').trim().toUpperCase();
    var number=parseFloat(text.replace(/[^0-9.]/g,''))||0;
    return text.indexOf('K')>-1?Math.round(number*1000):Math.round(number);
  }

  function setImageFallback(image){
    if(!image||image.dataset.ezarcFallback)return;
    image.dataset.ezarcFallback='true';
    image.src=image.dataset.fallbackSrc||imageFallback;
  }

  function setupHeroCarousel(){
    var heroProduct=q('.ezarc-hero__product');
    if(!heroProduct)return;
    var carousel=q('[data-hero-carousel]',heroProduct);
    if(!carousel&&!isShopify){
      carousel=document.createElement('div');
      carousel.className='ezarc-hero-carousel';
      carousel.setAttribute('data-hero-carousel','');
      var badge=document.createElement('div');
      badge.className='ezarc-hero-carousel__badge';
      badge.textContent='MYSTERY SLEEVE (1 of 6)';
      var slidesWrap=document.createElement('div');
      slidesWrap.className='ezarc-hero-carousel__slides';
      slidesWrap.setAttribute('aria-live','polite');
      var previewSlides=[
        ['green','assets/ezarc-product-802060-mood.png','Theme 01 | Digital Detox','Every order carries 1 randomized collectible mantra sleeve.'],
        ['orange','assets/ezarc-product-802067-mood.png','Theme 02 | Craft Pride','Built for the hands that do the work.'],
        ['blue','assets/ezarc-home-dad.webp','Theme 03 | Home Dad','For the home, for the ones I love.']
      ];
      previewSlides.forEach(function(item,index){
        var slide=document.createElement('figure');
        slide.className='ezarc-hero-carousel__slide ezarc-hero-carousel__slide--'+item[0]+(index===0?' is-active':'');
        slide.setAttribute('data-hero-slide','');
        var media=document.createElement('div');
        media.className='ezarc-hero-carousel__media';
        var image=document.createElement('img');
        image.src=item[1];
        image.alt=item[2];
        image.width=900;
        image.height=700;
        media.appendChild(image);
        var caption=document.createElement('figcaption');
        var title=document.createElement('strong');
        var note=document.createElement('small');
        title.textContent=item[2];
        note.textContent=item[3];
        caption.append(title,note);
        slide.append(media,caption);
        slidesWrap.appendChild(slide);
      });
      var dots=document.createElement('div');
      dots.className='ezarc-hero-carousel__dots';
      dots.setAttribute('role','tablist');
      dots.setAttribute('aria-label','Choose a mood sleeve');
      previewSlides.forEach(function(item,index){
        var dot=document.createElement('button');
        dot.type='button';
        dot.className='ezarc-hero-carousel__dot'+(index===0?' is-active':'');
        dot.setAttribute('data-hero-dot','');
        dot.setAttribute('data-mood',item[0]);
        dot.setAttribute('role','tab');
        dot.setAttribute('aria-label','Show '+item[2]);
        dot.setAttribute('aria-selected',index===0?'true':'false');
        dots.appendChild(dot);
      });
      carousel.append(badge,slidesWrap,dots);
      heroProduct.innerHTML='';
      heroProduct.appendChild(carousel);
    }
    if(!carousel)return;
    heroProduct.classList.add('ezarc-hero__product--carousel');
    var slides=qa('[data-hero-slide]',carousel);
    var dots=qa('[data-hero-dot]',carousel);
    if(!slides.length)return;
    var current=slides.findIndex(function(slide){return slide.classList.contains('is-active');});
    if(current<0)current=0;
    var timer;
    function show(index){
      current=(index+slides.length)%slides.length;
      slides.forEach(function(slide,slideIndex){slide.classList.toggle('is-active',slideIndex===current);});
      dots.forEach(function(dot,dotIndex){
        var active=dotIndex===current;
        dot.classList.toggle('is-active',active);
        dot.setAttribute('aria-selected',active?'true':'false');
      });
    }
    function restart(){
      window.clearInterval(timer);
      timer=window.setInterval(function(){show(current+1);},3500);
    }
    dots.forEach(function(dot,index){dot.addEventListener('click',function(){show(index);restart();});});
    show(current);
    restart();
  }

  function setupFallbackProductContent(){
    if(isShopify)return;
    var productData={
      allRound:{
        title:'Japanese Teeth Arc Edge 6 TPI Pruning Blade',
        kicker:'BEST SELLER / YARD & PRUNING',
        series:'BEST SELLER | YARD & PRUNING',
        intro:'A fast, controlled arc-edge blade for green branches, dry wood, and everyday pruning cleanup.',
        cover:productFallback.replace(/ezarc-product-802060\.png(?:\?.*)?$/,'ezarc-product-802060-mood.png'),
        fallback:productFallback,
        benefits:['Innovative Arc Edge Design (Better Leverage)','Aggressive Triple-Ground Japanese Teeth','2x Faster Cutting Speed in Green & Dry Wood'],
        quote:'Honestly works faster than a small chainsaw for branch cleanup. Effortless control.'
      },
      heavy:{
        title:'ProCut U-Groove Arc Edge Pruning Blade (Wet Wood Specialist)',
        kicker:'NEW UPGRADE / HEAVY-DUTY',
        series:'NEW UPGRADE | HEAVY-DUTY',
        intro:'A curved, wet-wood specialist built to clear sawdust quickly and stay composed in thick limbs.',
        cover:heavyProductFallback.replace(/ezarc-product-802067\.png(?:\?.*)?$/,'ezarc-product-802067-mood.png'),
        fallback:heavyProductFallback,
        benefits:['Patented U-Groove for Rapid Sawdust Evacuation','Anti-Bind Curved Profile for Thick Limbs','Premium Cr-V Steel with Impulse-Hardened Teeth'],
        quote:'Game changer for damp oak. Clears sawdust fast without stalling.'
      }
    };
    qa('.ezarc-bundle',root).forEach(function(card){
      var key=card.classList.contains('ezarc-bundle--heavy')?'heavy':'allRound';
      var data=productData[key];
      var title=q('h3',card),kicker=q('.ezarc-bundle__kicker',card),series=q('.ezarc-bundle__series',card),intro=q('.ezarc-bundle__intro',card),quote=q('blockquote',card),image=q('.ezarc-bundle__visual img',card);
      if(title)title.textContent=data.title;
      if(kicker)kicker.textContent=data.kicker;
      if(series)series.textContent=data.series;
      if(intro)intro.textContent=data.intro;
      if(quote)quote.innerHTML='<span>Builder voice</span>“'+data.quote+'”';
      if(image){image.src=data.cover;image.dataset.fallbackSrc=data.fallback;}
      var benefits=q('.ezarc-bundle__benefits',card);
      if(!benefits){
        benefits=document.createElement('ul');
        benefits.className='ezarc-bundle__benefits';
        if(intro)intro.after(benefits);
      }
      benefits.innerHTML=data.benefits.map(function(item){return'<li>'+item+'</li>';}).join('');
    });
  }

  function setupMantraEntryBanner(){
    var grid=q('#ezarc-mystery .ezarc-sleeve-grid');
    if(!grid||q('[data-mantra-wall-banner]',grid))return;
    var banner=document.createElement('div');
    banner.className='ezarc-mantra-co-banner';
    banner.setAttribute('data-mantra-wall-banner','');
    var copy=document.createElement('div');
    var title=document.createElement('strong');
    var note=document.createElement('span');
    var button=document.createElement('button');
    title.textContent=root.getAttribute('data-mantra-banner-title')||'Have a mantra that defines your craft?';
    note.textContent=root.getAttribute('data-mantra-banner-note')||'We might print it on our next sleeve edition.';
    button.type='button';
    button.className='ezarc-button ezarc-button--orange';
    button.setAttribute('data-mantra-open','');
    button.textContent=root.getAttribute('data-mantra-banner-button')||'✍️ Create & Pin Your Mantra';
    copy.append(title,note);
    banner.append(copy,button);
    grid.after(banner);
    if(window.EZARC_MANTRA_BIND)window.EZARC_MANTRA_BIND(banner);
  }

  function setupCommunity(){
    var community=q('#ezarc-ugc');
    if(!community)return;
    var grid=q('[data-ugc-grid]',community);
    if(!grid)return;
    var sourceItems=qa('[data-ugc-source-item]',root);
    var cards=qa('[data-ugc-card]',grid);
    var config=q('[data-ugc-config]',root);
    var initialRows=Math.max(1,parseInt(config&&config.getAttribute('data-ugc-initial-rows')||'3',10)||3);
    var viewMoreLabel=config&&config.getAttribute('data-ugc-view-more-label')||'View All Builder Stories';
    var viewLessLabel=config&&config.getAttribute('data-ugc-view-less-label')||'Show Fewer Builder Stories';
    var originalLabel=config&&config.getAttribute('data-ugc-original-label')||'View Original Post ↗';
    var defaultProductName=config&&config.getAttribute('data-ugc-default-product-name')||'EZARC Japanese Teeth Pruning Blade';
    var defaultProductLink=config&&config.getAttribute('data-ugc-default-product-link')||'#ezarc-products';
    var emptyText=config&&config.getAttribute('data-ugc-empty-text')||'Be the first builder to share your moment with #MySawBladeMyMood';
    var likedStories={};
    var expanded=false;
    var activeFilter='all';

    try{likedStories=JSON.parse(window.localStorage.getItem('ezarc-ugc-liked-v2')||'{}')||{};}catch(error){likedStories={};}

    function cardHandle(card){
      var name=q('.ezarc-ugc-card__identity strong',card);
      return name?name.textContent.trim():'story-'+card.getAttribute('data-ugc-order');
    }

    function cardData(card,index){
      var source=sourceItems[index];
      if(source){
        ['likes','authorLink','originalLink','videoUrl','productName','productLink'].forEach(function(key){
          var attr='data-ugc-'+key.replace(/[A-Z]/g,function(letter){return'-'+letter.toLowerCase();});
          var value=source.getAttribute(attr);
          if(value)card.setAttribute(attr,value);
        });
      }
      card.setAttribute('data-ugc-order',String(index));
      var count=q('[data-like-count]',card);
      var likes=parseLikes(card.getAttribute('data-ugc-likes')||count&&count.textContent||'0');
      if(likedStories[cardHandle(card)])likes+=1;
      card.setAttribute('data-ugc-likes',String(likes));
      if(count)count.textContent=formatLikes(likes);
      var original=card.getAttribute('data-ugc-original-link')||q('a',card)&&q('a',card).getAttribute('href')||'';
      card.setAttribute('data-ugc-original-link',original);
      card.setAttribute('data-ugc-author-link',card.getAttribute('data-ugc-author-link')||original);
      card.setAttribute('data-ugc-product-name',card.getAttribute('data-ugc-product-name')||defaultProductName);
      card.setAttribute('data-ugc-product-link',card.getAttribute('data-ugc-product-link')||defaultProductLink);
    }

    cards.forEach(cardData);

    function columnCount(){
      if(window.innerWidth<=680)return 2;
      if(window.innerWidth<=900)return 2;
      return 3;
    }

    function sortCards(){
      cards.sort(function(a,b){
        return parseLikes(b.getAttribute('data-ugc-likes'))-parseLikes(a.getAttribute('data-ugc-likes'))||Number(a.getAttribute('data-ugc-order'))-Number(b.getAttribute('data-ugc-order'));
      });
      cards.forEach(function(card){grid.appendChild(card);});
    }

    var expandWrap=q('[data-ugc-expand]',community);
    if(!expandWrap){
      expandWrap=document.createElement('div');
      expandWrap.className='ezarc-community__expand';
      expandWrap.setAttribute('data-ugc-expand','');
      var left=document.createElement('span');
      var toggle=document.createElement('button');
      var right=document.createElement('span');
      left.setAttribute('aria-hidden','true');
      right.setAttribute('aria-hidden','true');
      toggle.type='button';
      toggle.setAttribute('data-ugc-toggle','');
      expandWrap.append(left,toggle,right);
      grid.after(expandWrap);
    }
    var toggleButton=q('[data-ugc-toggle]',expandWrap);

    if(!cards.length&&!q('[data-ugc-empty]',community)){
      var empty=document.createElement('p');
      empty.className='ezarc-community__empty';
      empty.setAttribute('data-ugc-empty','');
      empty.textContent=emptyText;
      grid.after(empty);
    }

    function applyView(){
      sortCards();
      var matches=[];
      cards.forEach(function(card){
        var match=activeFilter==='all'||card.getAttribute('data-ugc-mood')===activeFilter;
        card.classList.toggle('is-filter-hidden',!match);
        if(match)matches.push(card);
      });
      var limit=expanded?Infinity:columnCount()*initialRows;
      matches.forEach(function(card,index){card.classList.toggle('is-collapsed',index>=limit);});
      var more=Math.max(0,matches.length-limit);
      expandWrap.hidden=matches.length<=columnCount()*initialRows;
      if(toggleButton){
        toggleButton.textContent=expanded?viewLessLabel:viewMoreLabel+' ('+more+' more)';
        toggleButton.setAttribute('aria-expanded',expanded?'true':'false');
      }
    }

    qa('[data-ugc-filter]',community).forEach(function(filter){
      filter.addEventListener('click',function(){
        activeFilter=filter.getAttribute('data-ugc-filter')||'all';
        expanded=false;
        qa('[data-ugc-filter]',community).forEach(function(item){
          var selected=item===filter;
          item.classList.toggle('is-active',selected);
          item.setAttribute('aria-selected',selected?'true':'false');
        });
        applyView();
      });
    });

    if(toggleButton)toggleButton.addEventListener('click',function(){
      expanded=!expanded;
      applyView();
      if(!expanded)grid.scrollIntoView({behavior:'smooth',block:'start'});
    });

    var copyHost=q('.ezarc-community__header-copy',community);
    if(copyHost&&!q('[data-copy-hashtag]',copyHost)){
      var copyButton=document.createElement('button');
      copyButton.type='button';
      copyButton.className='ezarc-community-copy';
      copyButton.setAttribute('data-copy-hashtag','');
      copyButton.textContent='#WeAreAllBuilders #MySawBladeMyMood 📋';
      copyHost.appendChild(copyButton);
      copyButton.addEventListener('click',function(){
        var text='#WeAreAllBuilders #MySawBladeMyMood';
        var done=function(){
          copyButton.textContent='Copied! 🎉';
          copyButton.classList.add('is-copied');
          window.setTimeout(function(){
            copyButton.textContent='#WeAreAllBuilders #MySawBladeMyMood 📋';
            copyButton.classList.remove('is-copied');
          },2000);
        };
        if(navigator.clipboard&&navigator.clipboard.writeText){
          navigator.clipboard.writeText(text).then(done).catch(done);
        }else{
          var field=document.createElement('textarea');
          field.value=text;
          field.style.position='fixed';
          field.style.opacity='0';
          document.body.appendChild(field);
          field.select();
          try{document.execCommand('copy');}catch(error){}
          field.remove();
          done();
        }
      });
    }

    var lightbox=document.createElement('div');
    lightbox.className='ezarc-ugc-lightbox';
    lightbox.setAttribute('aria-hidden','true');
    lightbox.setAttribute('role','dialog');
    lightbox.setAttribute('aria-modal','true');
    lightbox.setAttribute('aria-labelledby','ezarc-lightbox-title');
    lightbox.innerHTML='<div class="ezarc-ugc-lightbox__panel"><button type="button" class="ezarc-ugc-lightbox__close" data-lightbox-close aria-label="Close story">&times;</button><div class="ezarc-ugc-lightbox__media"><img data-lightbox-image alt=""><video data-lightbox-video controls playsinline preload="metadata" hidden></video><span data-lightbox-type></span></div><div class="ezarc-ugc-lightbox__content"><p class="ezarc-eyebrow ezarc-eyebrow--light">COMMUNITY BUILDER STORY</p><a class="ezarc-ugc-lightbox__author" data-lightbox-author id="ezarc-lightbox-title" target="_blank" rel="noopener noreferrer"></a><p class="ezarc-ugc-lightbox__location" data-lightbox-location></p><p class="ezarc-ugc-lightbox__caption" data-lightbox-caption></p><a class="ezarc-ugc-lightbox__original" data-lightbox-original target="_blank" rel="noopener noreferrer">'+originalLabel+'</a><div class="ezarc-ugc-lightbox__product"><strong data-lightbox-product></strong><a class="ezarc-button ezarc-button--orange" href="#ezarc-products" data-lightbox-shop>Shop This Blade (10% OFF)</a></div></div></div>';
    document.body.appendChild(lightbox);

    var lightboxImage=q('[data-lightbox-image]',lightbox);
    var lightboxVideo=q('[data-lightbox-video]',lightbox);
    var lightboxType=q('[data-lightbox-type]',lightbox);
    var lightboxAuthor=q('[data-lightbox-author]',lightbox);
    var lightboxLocation=q('[data-lightbox-location]',lightbox);
    var lightboxCaption=q('[data-lightbox-caption]',lightbox);
    var lightboxOriginal=q('[data-lightbox-original]',lightbox);
    var lightboxProduct=q('[data-lightbox-product]',lightbox);
    var lightboxShop=q('[data-lightbox-shop]',lightbox);
    var lastFocus;

    function closeLightbox(){
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden','true');
      document.body.classList.remove('ezarc-lightbox-open');
      if(lightboxVideo){lightboxVideo.pause();lightboxVideo.removeAttribute('src');lightboxVideo.hidden=true;}
      if(lightboxImage){lightboxImage.removeAttribute('src');lightboxImage.hidden=false;}
      if(lastFocus)lastFocus.focus();
    }

    function openLightbox(card){
      var image=q('.ezarc-ugc-card__media img',card);
      var videoUrl=(card.getAttribute('data-ugc-video-url')||'').trim();
      if(!image&&!videoUrl)return;
      lastFocus=document.activeElement;
      if(videoUrl&&lightboxVideo){
        lightboxVideo.src=videoUrl;
        lightboxVideo.hidden=false;
        if(lightboxImage)lightboxImage.hidden=true;
      }else{
        if(lightboxImage){
          lightboxImage.src=image.currentSrc||image.src;
          lightboxImage.alt=image.alt||'';
          lightboxImage.hidden=false;
        }
        if(lightboxVideo){lightboxVideo.pause();lightboxVideo.removeAttribute('src');lightboxVideo.hidden=true;}
      }
      lightboxType.textContent=(q('.ezarc-ugc-card__type',card)||{}).textContent||'';
      var handle=cardHandle(card);
      var originalLink=card.getAttribute('data-ugc-original-link')||'';
      var authorLink=card.getAttribute('data-ugc-author-link')||originalLink;
      lightboxAuthor.textContent=handle||'Builder';
      lightboxAuthor.href=authorLink||'#';
      lightboxLocation.textContent=(q('.ezarc-ugc-card__identity small',card)||{}).textContent||'';
      lightboxCaption.textContent=(q('.ezarc-ugc-card__caption',card)||{}).textContent||'';
      lightboxOriginal.href=originalLink||'#';
      lightboxOriginal.hidden=!originalLink;
      lightboxProduct.textContent='Used in this project: '+(card.getAttribute('data-ugc-product-name')||defaultProductName);
      lightboxShop.href=card.getAttribute('data-ugc-product-link')||defaultProductLink;
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden','false');
      document.body.classList.add('ezarc-lightbox-open');
      q('[data-lightbox-close]',lightbox).focus();
    }

    lightbox.addEventListener('click',function(event){
      if(event.target===lightbox||event.target.closest('[data-lightbox-close]'))closeLightbox();
    });
    lightboxShop.addEventListener('click',closeLightbox);
    document.addEventListener('keydown',function(event){if(event.key==='Escape'&&lightbox.classList.contains('is-open'))closeLightbox();});

    root.addEventListener('click',function(event){
      var like=event.target.closest('[data-like]');
      if(like&&root.contains(like)){
        event.preventDefault();
        event.stopPropagation();
        var card=like.closest('[data-ugc-card]');
        if(!card)return;
        var key=cardHandle(card);
        if(likedStories[key])return;
        var next=parseLikes(card.getAttribute('data-ugc-likes'))+1;
        card.setAttribute('data-ugc-likes',String(next));
        var count=q('[data-like-count]',card);
        if(count)count.textContent=formatLikes(next);
        likedStories[key]=true;
        try{window.localStorage.setItem('ezarc-ugc-liked-v2',JSON.stringify(likedStories));}catch(error){}
        like.classList.add('is-liked','is-popping');
        like.setAttribute('aria-pressed','true');
        var heart=q('span',like);
        if(heart)heart.textContent='♥';
        window.setTimeout(function(){like.classList.remove('is-popping');applyView();},450);
        return;
      }
      var cardTarget=event.target.closest('[data-ugc-card]');
      if(cardTarget&&root.contains(cardTarget)){
        event.preventDefault();
        event.stopPropagation();
        openLightbox(cardTarget);
      }
    });

    window.addEventListener('resize',applyView);
    applyView();
  }

  function setupGlobalBehaviors(){
    qa('img',root).forEach(function(image){
      if(image.complete&&!image.naturalWidth)setImageFallback(image);
      image.addEventListener('error',function(){setImageFallback(image);});
    });
    qa('a[href^="#"]',root).forEach(function(link){
      link.addEventListener('click',function(event){
        var target=document.querySelector(link.getAttribute('href'));
        if(!target)return;
        event.preventDefault();
        target.scrollIntoView({behavior:'smooth',block:'start'});
      });
    });
    var reveals=qa('.ezarc-reveal');
    if('IntersectionObserver' in window){
      var observer=new IntersectionObserver(function(items){items.forEach(function(item){if(item.isIntersecting){item.target.classList.add('is-visible');observer.unobserve(item.target);}});},{threshold:.12});
      reveals.forEach(function(item){observer.observe(item);});
    }else{reveals.forEach(function(item){item.classList.add('is-visible');});}
  }

  setupHeroCarousel();
  setupFallbackProductContent();
  setupMantraEntryBanner();
  setupCommunity();
  setupGlobalBehaviors();

  if(!isShopify){
    var heroNote=q('.ezarc-dual-actions .ezarc-button--dark .ezarc-button__text small');
    if(heroNote)heroNote.textContent='Use: EZARSAVE10 for 10% Off';
  }
})();
